module.exports = __webpack_public_path__ + "img/type.1db02969.svg";